import { Textarea } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import IconAIEdit from '~/components/icons/IconAIEdit';

const ICON_SIZE = 15;

export default function ActionSearchBox({
  textareaRef,
  handleKeyDown,
  isCustomActionsMode,
  search,
  setSearch,
  className,
}: {
  textareaRef: React.RefObject<HTMLTextAreaElement | null>;
  handleKeyDown: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  isCustomActionsMode: boolean;
  search: string;
  setSearch: (search: string) => void;
  className?: string;
}) {
  return (
    <Textarea
      className={className}
      ref={textareaRef}
      onKeyDown={handleKeyDown}
      autosize
      autoFocus
      data-autofocus
      spellCheck={false}
      onFocus={(e) => {
        const { value } = e.target;
        e.target.value = '';
        e.target.value = value;
      }}
      minRows={isCustomActionsMode ? 5 : 1}
      maxRows={8}
      placeholder={isCustomActionsMode ? 'Describe the user flow to test' : 'Search...'}
      leftSection={
        isCustomActionsMode ?
          <IconAIEdit className="mt-1.5 h-4 w-4 text-gray-700 dark:text-gray-300" />
        : <IconSearch
            size={ICON_SIZE}
            className="mt-2 text-gray-600 dark:text-gray-400"
          />
      }
      value={search}
      onChange={(event) => setSearch(event.currentTarget.value)}
      classNames={{
        input: 'pt-[6px] bg-gray-50 dark:bg-stone-900/30',
        section: 'items-start',
      }}
    />
  );
}
